import { useTeams } from '../ygdrasil/libs/QueryHooks'
import useAppState from './useAppState'

export default function useSelectedTeam() {
  const { state } = useAppState()
  const { selectedTeamId } = state
  const { data: teams = [] } = useTeams(state)
  return teams.find(({ _id }) => _id === selectedTeamId)
}
